(function(){
  document.addEventListener('DOMContentLoaded', function() {
    let tabsControlsActive = document.querySelector('.filter_strip--item.active');
    let dataTab = tabsControlsActive.getAttribute('data-tab');
    let tabContent = document.querySelectorAll(`[data-tab="${dataTab}"]`);
    document.querySelectorAll('[data-tab]').forEach( elem => {
      elem.classList.remove('active');
    });
    tabContent.forEach(elem => {
      elem.classList.add('active');
    });
    
   let tabsControls = document.querySelectorAll('.filter_strip--item');
    tabsControls.forEach( elem => {
      elem.addEventListener('click', function(e) {
        e.preventDefault();
        let dataTab = elem.getAttribute('data-tab');
        let tabContent = document.querySelectorAll(`[data-tab="${dataTab}"]`);
        document.querySelectorAll('[data-tab]').forEach( elem => {
          elem.classList.remove('active');
        });
        elem.classList.add('active');
        tabContent.forEach(elem => {
          elem.classList.add('active');
        });
      });
    });
 }, false);
})();
